export const TemplatePlaceholders = {
    avis : [
        'LOGO',
        'REFERENCE_NUMBER',
        'DATE',
        'TIN',
        'COMPANY_NAME',
        'DEC_TYPE',
        'MUNICIPALITY',
        'ADDRESS',
        'DISTRICT',
        'LOCALITY',
        'STREET_NAME',
        'STREET_NUMBER',
        'AREA',
        'AVISTABLE',
        'CURRENCY',
        'AMOUNT_WRITTEN',
        'AMOUNT',
        'NOW',
        'BARCODE',
        'DUE_DATE',
        'PHONE_NUMBER',
        'DEPARTMENT',
        'REGION',
        'PAYMENT_QR',
        'PROFILE_IMAGE'
    ],

    company : [
        'LOGO',
        'TIN',
        'TYPE',
        'T_TIN_CODE',
        'MUNICIPALITY',
        'DISTRICT',
        'STREET_NAME',
        'STREET_NUMBER',
        'AREA',
        'COMPANY_NAME',
        'PHONE_NUMBER',
        'REGION',
        'DEPARTMENT',
        'NOW',
        'BARCODE',
        'PAYMENT_QR',
        'PROFILE_IMAGE'
    ],

    pdf : [
        'LOGO',
        'HEADER'
    ],

    declaration : [
        'LOGO',
        'REFERENCE_NUMBER',
        'DATE',
        'TIN',
        'COMPANY_NAME',
        'DEC_TYPE',
        'MUNICIPALITY',
        'ADDRESS',
        'DISTRICT',
        'LOCALITY',
        'CURRENCY',
        'AMOUNT',
        'AMOUNT_WRITTEN',
        'NOW',
        'BARCODE',
        'DUE_DATE',
        'PHONE_NUMBER',
        'DEPARTMENT',
        'REGION',
        'PAYMENT_QR',
        'PROFILE_IMAGE',
    ],

    submission : [
        'LOGO',
        'REFERENCE_NUMBER',
        'DATE',
        'TIN',
        'COMPANY_NAME',
        'DEC_TYPE',
        'MUNICIPALITY',
        'ADDRESS',
        'DISTRICT',
        'LOCALITY',
        'SUBMISSION_TABLE',
        'CURRENCY',
        'AMOUNT_WRITTEN',
        'DUE_DATE',
        'PHONE_NUMBER',
        'DEPARTMENT',
        'REGION'
    ]
  };